<template>
	<div class="header">
		<header class="header_app" v-bind:class="{'d-none': headerActive()}">
		<nav class="navbar navbar-expand-lg navbar-light">
		  <a class="navbar-brand" href="#"><img src="../assets/logo.jpeg" alt=""></a>
		  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
		    <span class="navbar-toggler-icon"></span>
		  </button>
		  <div class="collapse navbar-collapse" id="navbarSupportedContent">
		    <ul class="navbar-nav mr-auto">
		      <li class="nav-item" v-bind:class="{'active': currentPage('donate')}">
		        <router-link :to="{ name: 'Donate_step1' }"><button>Snel doneren</button></router-link>
		      </li>
		      <li class="nav-item" v-bind:class="{'active': currentPage('donator')}">
		        <router-link :to="{ name: 'Donator_step1' }"><button>Donateur worden</button></router-link>
		      </li>
		      <li class="nav-item" v-bind:class="{'active': currentPage('more_info')}">
		        <router-link :to="{ name: 'About' }"><button>Meer info</button></router-link>
		      </li>
		    </ul>
		  </div>
		</nav>
	</header>
	<header>
		<div class="row">
			<div class="col" v-bind:class="{'d-none': alterHeaderActive()}">
				<img src="../assets/logo.jpeg" width="200" alt="">
			</div>
		</div>
	</header>
	</div>
</template>

<script>
export default {
  name: 'Header',
  methods:{
    currentPage: function(page){  
	    var path = this.$route.path;
	    var split = path.split('/');  
      if(split[1] == page){
        return true;
      }
    },
    headerActive: function(){
    	var path = this.$route.path;
	    var split = path.split('/'); 
	    console.log(split); 

	    switch(split[1]){
	    	case '':
	    	case 'menu':
	    		return true;
	    	break;
	    	default:
	    		return false;
	    }
    },
    alterHeaderActive: function(){
    	var path = this.$route.path;
	    var split = path.split('/'); 
	    console.log(split); 

	    switch(split[1]){
	    	case 'menu':
	    		return false;
	    	break;
	    	default:
	    		return true;
	    }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Header.vue